// extracted by mini-css-extract-plugin
module.exports = {"root":"CanvasAboutSection_root__UOrN8"};